import React from 'react';

const SvgSearch = React.forwardRef((props, ref) => (
    <svg
        ref={ref}
        className="Search_svg__icon Search_svg__icon-search"
        viewBox="0 0 21.178 21.636"
        fill="none"
        aria-hidden="true"
        width="1em"
        height="1em"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
      <path
          d="M9.989 18.978A8.989 8.989 0 1 0 9.989 1a8.989 8.989 0 0 0 0 17.978z"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
      />
      <path
          d="m16.24 16.707 3.524 3.515"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="square"
          strokeLinejoin="round"
      />
    </svg>
));

export default SvgSearch;
